import { GlobalOutlined, SearchOutlined } from '@ant-design/icons';
import { FaLevelUpAlt } from 'react-icons/fa';
import { Button, Col, Input, Row, Select, Space, Typography } from 'antd';
import PropTypes from 'prop-types';
import { memo } from 'react';
import useTranslation from '@/hooks/useTranslation';
import AsyncPlaceSelect from '@/components/common/AsyncPlaceSelect';

function SponsorFiltersRow({
    isFull,
    showTitle = true,
    title,
    setFilter,
    searchText,
    setSearchText,
    levelProps,
    countryOptions,
}) {
    const { t } = useTranslation();
    const columnProps = isFull ? { span: 24 } : { xl: 4, lg: 6, md: 8, sm: 8, xs: 24 };

    const handleSearch = () => {
        setFilter((previousFilter) => {
            if (previousFilter.search === searchText && previousFilter.page === 1) {
                return previousFilter;
            }
            return { ...previousFilter, search: searchText, page: 1 };
        });
    };

    return (
        <Row gutter={[16, 16]} justify="end" align="middle">
            {showTitle && (
                <Col flex="auto">
                    <Typography.Title level={4}>{title}</Typography.Title>
                </Col>
            )}
            <Col {...columnProps}>
                <Select
                    allowClear
                    showSearch
                    size="large"
                    placeholder={t('sponsor_filters.search_by_level')}
                    style={{ width: '100%' }}
                    prefix={<FaLevelUpAlt />}
                    {...levelProps}
                    onChange={(_, option) => setFilter((previousFilter) => ({ ...previousFilter, level: option?.name, page: 1 }))}
                />
            </Col>
            <Col {...columnProps}>
                <AsyncPlaceSelect
                    prefix={<GlobalOutlined />}
                    size="large"
                    filterByCountry={true}
                    placeholder={t('sponsor_filters.search_by_country')}
                    onChange={(_,option)=>{
                        setFilter((previousFilter) => ({ ...previousFilter, country: option?.label, page: 1 }))
                    }}
                />
            </Col>
            <Col {...columnProps}>
                <Space.Compact size="large" style={{ width: '100%' }}>
                    <Input
                        allowClear
                        placeholder={t('sponsor_filters.search')}
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(event) => setSearchText(event.target.value)}
                        onPressEnter={handleSearch}
                        onClear={() => setFilter((previousFilter) => ({ ...previousFilter, search: '', page: 1 }))}
                    />
                    <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch} />
                </Space.Compact>
            </Col>
        </Row>
    );
}

SponsorFiltersRow.propTypes = {
    isFull: PropTypes.bool,
    showTitle: PropTypes.bool,
    title: PropTypes.string,
    setFilter: PropTypes.func,
    searchText: PropTypes.string,
    setSearchText: PropTypes.func,
    levelProps: PropTypes.shape({
        options: PropTypes.array,
        onChange: PropTypes.func,
        allowClear: PropTypes.bool,
        defaultActiveFirstOption: PropTypes.bool,
        loading: PropTypes.bool,
        placeholder: PropTypes.string,
        showSearch: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    }),
    countryOptions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.string,
        }),
    ),
};

export default memo(SponsorFiltersRow);
